import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // resources: {
    //   en: {
    //     translation: {
    //       Welcome: {
    //         text: "Welcome to this React Internationalization App",
    //       },
    //     },
    //   },
    //   fr: {
    //     translation: {
    //       Welcome: {
    //         text: "Bienvenue sur cette application d'internationalisation React",
    //       },
    //     },
    //   },
    // },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
